module.exports = __webpack_public_path__ + "static/media/logo-black.53706e50.png";